import { getUnitIcon, Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { getUnitTranslationKey, guardString } from "@msuite/utils/strings";
import type { Enums, Nullable } from "@msuite/utils/types";

/** Props Interface */
interface UnitTag {
	unit: Nullable<Enums<"unit">>;
}

export function UnitTag({ unit }: UnitTag) {
	/** Hooks */
	const { t } = useTranslation();

	if (!unit) return guardString(null);

	/** Render */
	return (
		<div className="h-stack">
			<Icon
				name={getUnitIcon(unit)}
				className="stroke-accent-500 fill-accent-500/20"
			/>
			<p>{t(getUnitTranslationKey(unit))}</p>
		</div>
	);
}
